import { apiFetch } from './client';

export type OrgRole = 'owner' | 'admin' | 'member' | 'reviewer' | 'auditor';

export interface OrgMember {
  id: string;
  orgId: string;
  userId: string;
  role: OrgRole;
  createdAt: string;
  user: { id: string; email: string; name: string | null };
}

export interface Org {
  id: string;
  name: string;
  slug: string;
  createdAt: string;
}

export const getOrg = (orgId: string) => apiFetch<Org>(`/orgs/${orgId}`);

export const getMembers = (orgId: string) =>
  apiFetch<OrgMember[]>(`/orgs/${orgId}/members`);

export interface AddMemberParams {
  email: string;
  role: OrgRole;
}

// The API adds an EXISTING registered user to the org by email (it does not send an invite email).
export const addMember = (orgId: string, params: AddMemberParams) =>
  apiFetch<OrgMember>(`/orgs/${orgId}/members`, {
    method: 'POST',
    body: JSON.stringify(params),
  });
